import React from "react";

/**
 * @param {{ active: 'board' | 'overview', onChange: (t: 'board' | 'overview') => void }} props
 */
function PipelineTabs({ active, onChange }) {
  const tab = (id, label) => {
    const isOn = active === id;
    return (
      <button
        type="button"
        role="tab"
        aria-selected={isOn}
        onClick={() => onChange(id)}
        className={`pb-3 px-1 text-sm font-semibold border-b-2 transition-colors ${
          isOn
            ? "text-orange-600 border-orange-500"
            : "text-gray-500 border-transparent hover:text-gray-800"
        }`}
      >
        {label}
      </button>
    );
  };

  return (
    <div className="flex gap-8" role="tablist">
      {tab("board", "Board")}
      {tab("overview", "Overview")}
    </div>
  );
}

export default PipelineTabs;
